<template>
  <div>
    <p
      v-if="RangeMaxXTextCtrller.value!=='' ||RangeMinXTextCtrller.value!==''"
      class="range-display"
    >
      <span v-if="RangeMinXTextCtrller.value!==''">{{ RangeMinXTextCtrller.value }}&#60;</span>
      <span> x </span>
      <span v-if="RangeMaxXTextCtrller.value!==''">&#60;{{ RangeMaxXTextCtrller.value }}</span>
    </p>
    <p
      v-else
      class="range-display"
    >
      Entire timeline
    </p>
    <TextInputConfiguration
      :controller="RangeMinXTextCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
    <TextInputConfiguration
      class="mb-2"
      :controller="RangeMaxXTextCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
    <p
      v-if="RangeMaxYTextCtrller.value!=='' ||RangeMinYTextCtrller.value!==''"
      class="range-display"
    >
      <span v-if="RangeMinYTextCtrller.value!==''">{{ RangeMinYTextCtrller.value }}&#60;</span>
      <span> y </span>
      <span v-if="RangeMaxYTextCtrller.value!==''">&#60;{{ RangeMaxYTextCtrller.value }}</span>
    </p>
    <p
      v-else
      class="range-display"
    >
      Entire timeline
    </p>
    <TextInputConfiguration
      :controller="RangeMinYTextCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
    <TextInputConfiguration
      :controller="RangeMaxYTextCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
  </div>
</template>

<script>
import {inputTextConfCtrller} from '@/assets/classes/configuration.js'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'

export default {
  name: 'AxisRange',
  components:{
    TextInputConfiguration,
  },
  props: {
    sectionconfig:{
      type:String,
      required:true
    }
  },
  data() {
    return {
      elementsConfig:[],
      RangeMinYTextCtrller:new inputTextConfCtrller('RANGE_MIN_Y_FLOAT','Min Y','Please give a numerical value or leave it empty to consider all the graph','',(value)=>{return !isNaN(value) ||value===''}),
      RangeMaxYTextCtrller:new inputTextConfCtrller('RANGE_MAX_Y_FLOAT','Max Y','Please give a numerical value or leave it empty to consider all the graph','',(value)=>{return !isNaN(value) ||value===''}),
      RangeMinXTextCtrller: new inputTextConfCtrller('RANGE_MIN_FLOAT','Min X','Please give a numerical value or leave it empty to consider all the graph','',(value)=>{return !isNaN(value) ||value===''}),
      RangeMaxXTextCtrller: new inputTextConfCtrller('RANGE_MAX_FLOAT','Max X','Please give a numerical value or leave it empty to consider all the graph','',(value)=>{return !isNaN(value) ||value===''}),
    }
  },
  mounted(){
    this.elementsConfig = [
      this.RangeMinYTextCtrller,
      this.RangeMaxYTextCtrller,
      this.RangeMinXTextCtrller,
      this.RangeMaxXTextCtrller,
    ]
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.setParent(this))
  },
}
</script>

<style>
.range-display{
  font-weight: bold;
  text-align: center;
  font-size: 0.8rem;
}
</style>